export const DEFAULT_MEETING_TITLE: string = 'Office hours';
export const DEFAULT_MEETING_DURATION: number = 30;
